/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/patchSegmentOverrides';
import type { PatchSegmentRequestBody } from '../../operation-overrides/patchSegmentOverrides';

export type PatchSegmentPathParams = NonNullable<operations['patchSegment']['parameters']['path']>;

export type PatchSegmentQueryParams = NonNullable<operations['patchSegment']['parameters']['query']>;
export type { PatchSegmentRequestBody };

export interface Input extends PatchSegmentPathParams {
  apiVersion?: string;
  query?: PatchSegmentQueryParams;
  body: PatchSegmentRequestBody;
}

export async function patchSegment(
  { apiVersion, body, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/segments/{projectKey}/{environmentKey}/{segmentKey}', {
    params: { path, query },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    body,
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    bodySerializer: overrides.bodySerializer,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
